// extracted by mini-css-extract-plugin
export default {"br_footer":"br_footer___VS2Ie","content_wrapper":"content_wrapper___f_CCi","content":"content___Eea9o","links":"links___M5kUW"};